// extracted by mini-css-extract-plugin
module.exports = {"wz6vz5e":"wz6vz5e"};